import { agentPresentationController } from "@/lib/agent-presentation-controller";
import type { useCanvasStore } from "@/stores/canvas-store";

type CursorState = Pick<
  ReturnType<typeof useCanvasStore.getState>,
  "agentCursors" | "clearPresentedCursors"
>;

/** Runtime acceptance is not visual cancellation. Keep an in-flight drawing's
 * display, marks, and execution identity until its controller finishes it. */
export function preservePresentationOnExecutionStart(
  state: CursorState,
  spaceId: string | undefined,
  cursorKey: string,
  agentName: string | undefined,
  clearCompleted: boolean,
): boolean {
  const active = agentPresentationController.getSnapshot();
  const deliveryId =
    active &&
    active.lifecycle !== "completed" &&
    active.lifecycle !== "cancelled"
      ? active.presentationId
      : undefined;
  let preservesCursor = false;
  let hasActiveCursor = false;
  for (const [key, cursor] of state.agentCursors) {
    if (spaceId && cursor.spaceId !== spaceId) continue;
    if (!deliveryId || cursor.presentationDeliveryId !== deliveryId) continue;
    hasActiveCursor = true;
    if (key === cursorKey || (agentName && cursor.name === agentName)) {
      preservesCursor = true;
    }
  }
  if (clearCompleted && !hasActiveCursor) {
    state.clearPresentedCursors(spaceId);
  }
  return preservesCursor;
}
